import React, { memo } from 'react';
import { useParams, Link } from 'react-router-dom';
import { ChevronRightIcon, StarIcon, ShieldIcon, TruckIcon, RefreshCcwIcon, InfoIcon, MinusIcon, PlusIcon } from 'lucide-react';
export const ProductPage = () => {
  const {
    id
  } = useParams();
  // Mock product data - in a real app, this would come from an API
  const product = {
    id: 1,
    name: 'MacBook Pro 14" 2021',
    category: 'electronics',
    condition: 'Refurbished - Excellent',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/pVpXANE4MPeUTAwYJSN7su/Screenshot_2025-08-06_at_07.25.36.png',
    price: 1299,
    originalPrice: 1699,
    discount: '30%',
    description: 'This certified refurbished MacBook Pro has been professionally restored to excellent working condition. Each device undergoes rigorous testing and quality assurance to ensure optimal performance.',
    specs: ['Apple M1 Pro chip with 8-core CPU and 14-core GPU', '16GB unified memory', '512GB SSD storage', '14-inch Liquid Retina XDR display, 3024 x 1964 resolution', 'Magic Keyboard with Touch ID'],
    rating: 4.7,
    reviews: 127,
    inStock: true
  };
  const relatedProducts = [{
    id: 2,
    name: 'MacBook Air M2',
    condition: 'Refurbished - Excellent',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/pVpXANE4MPeUTAwYJSN7su/Screenshot_2025-08-06_at_07.25.36.png',
    price: 899,
    originalPrice: 1099,
    discount: '18%'
  }, {
    id: 3,
    name: 'iPad Pro 12.9"',
    condition: 'Refurbished - Like New',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/pVpXANE4MPeUTAwYJSN7su/Screenshot_2025-08-06_at_07.25.36.png',
    price: 899,
    originalPrice: 1099,
    discount: '18%'
  }, {
    id: 4,
    name: 'iPhone 14 Pro',
    condition: 'Refurbished - Like New',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bngTbbaTJ7wdgAETVR58Qf/Screenshot_2025-08-06_at_07.30.39.png',
    price: 899,
    originalPrice: 999,
    discount: '10%'
  }];
  return <div className="bg-gray-50 min-h-screen w-full" data-id="element-560">
      <div className="container mx-auto px-4 py-8" data-id="element-561">
        {/* Breadcrumb */}
        <div className="flex items-center text-sm text-gray-500 mb-6" data-id="element-562">
          <Link to="/" className="hover:text-green-500 transition-colors" data-id="element-563">
            Home
          </Link>
          <ChevronRightIcon size={16} className="mx-2" data-id="element-564" />
          <Link to="/shop" className="hover:text-green-500 transition-colors" data-id="element-565">
            Electronics
          </Link>
          <ChevronRightIcon size={16} className="mx-2" data-id="element-566" />
          <span className="text-gray-700" data-id="element-567">MacBook Pro 2021</span>
        </div>
        <div className="bg-white rounded-xl shadow-sm overflow-hidden" data-id="element-568">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 p-6" data-id="element-569">
            {/* Product Image */}
            <div className="flex items-center justify-center bg-gray-50 rounded-lg p-8" data-id="element-570">
              <img src={product.image} alt={product.name} className="object-contain max-h-80 mx-auto" data-id="element-571" />
            </div>
            {/* Product Details */}
            <div data-id="element-572">
              <span className="inline-block bg-green-100 text-green-600 text-xs font-semibold px-2 py-1 rounded-full mb-3" data-id="element-573">
                CERTIFIED REFURBISHED
              </span>
              <h1 className="text-2xl font-bold mb-2" data-id="element-574">{product.name}</h1>
              <div className="flex items-center mb-4" data-id="element-575">
                <div className="flex items-center" data-id="element-576">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} size={16} className={i < Math.floor(product.rating) ? 'text-amber-400 fill-amber-400' : 'text-gray-300'} data-id="element-577" />)}
                </div>
                <span className="text-sm text-gray-500 ml-2" data-id="element-578">
                  ({product.reviews} reviews)
                </span>
              </div>
              <div className="flex items-center mb-6" data-id="element-579">
                <span className="text-3xl font-bold" data-id="element-580">${product.price}</span>
                {product.originalPrice && <span className="text-lg text-gray-500 line-through ml-3" data-id="element-581">
                    ${product.originalPrice}
                  </span>}
                {product.discount && <span className="ml-3 bg-green-50 text-green-600 text-sm font-semibold px-2 py-1 rounded" data-id="element-582">
                    {product.discount} OFF
                  </span>}
              </div>
              <div className="mb-6" data-id="element-583">
                <h3 className="text-sm font-medium text-gray-700 mb-2" data-id="element-584">
                  Condition:
                </h3>
                <div className="flex items-center" data-id="element-585">
                  <span className="font-medium text-gray-800" data-id="element-586">
                    {product.condition}
                  </span>
                  <button className="ml-2 text-gray-400 hover:text-gray-600" data-id="element-587">
                    <InfoIcon size={16} data-id="element-588" />
                  </button>
                </div>
              </div>
              <div className="mb-6" data-id="element-589">
                <h3 className="text-sm font-medium text-gray-700 mb-2" data-id="element-590">
                  Quantity:
                </h3>
                <div className="flex items-center" data-id="element-591">
                  <button className="bg-gray-100 text-gray-600 p-2 rounded-l-lg hover:bg-gray-200 transition-colors" data-id="element-592">
                    <MinusIcon size={16} data-id="element-593" />
                  </button>
                  <input type="text" value="1" className="w-16 text-center border-t border-b border-gray-200 py-2" readOnly data-id="element-594" />
                  <button className="bg-gray-100 text-gray-600 p-2 rounded-r-lg hover:bg-gray-200 transition-colors" data-id="element-595">
                    <PlusIcon size={16} data-id="element-596" />
                  </button>
                </div>
              </div>
              <div className="flex flex-col sm:flex-row gap-4 mb-8" data-id="element-597">
                <button className="flex-1 bg-green-500 text-white py-3 px-6 rounded-lg hover:bg-green-600 transition-colors" data-id="element-598">
                  Add to Cart
                </button>
                <button className="flex-1 bg-white text-green-500 border border-green-500 py-3 px-6 rounded-lg hover:bg-green-50 transition-colors" data-id="element-599">
                  Buy Now
                </button>
              </div>
              <div className="flex flex-col gap-3" data-id="element-600">
                <div className="flex items-center text-gray-600" data-id="element-601">
                  <ShieldIcon size={16} className="mr-2" data-id="element-602" />
                  <span data-id="element-603">30-Day Warranty</span>
                </div>
                <div className="flex items-center text-gray-600" data-id="element-604">
                  <TruckIcon size={16} className="mr-2" data-id="element-605" />
                  <span data-id="element-606">Free Shipping</span>
                </div>
                <div className="flex items-center text-gray-600" data-id="element-607">
                  <RefreshCcwIcon size={16} className="mr-2" data-id="element-608" />
                  <span data-id="element-609">30-Day Returns</span>
                </div>
              </div>
            </div>
          </div>
          {/* Product Description and Specs */}
          <div className="border-t border-gray-200 p-6" data-id="element-610">
            <div className="mb-8" data-id="element-611">
              <h2 className="text-xl font-bold mb-4" data-id="element-612">Product Details</h2>
              <p className="text-gray-600 mb-4" data-id="element-613">{product.description}</p>
              <h3 className="font-medium mb-2" data-id="element-614">Features include:</h3>
              <ul className="list-disc pl-5 text-gray-600 space-y-1" data-id="element-615">
                {product.specs.map((spec, index) => <li key={index} data-id="element-616">{spec}</li>)}
              </ul>
            </div>
            <div data-id="element-617">
              <h2 className="text-xl font-bold mb-4" data-id="element-618">Specifications</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-619">
                <div className="bg-gray-50 p-4 rounded-lg" data-id="element-620">
                  <h3 className="font-medium mb-2" data-id="element-621">Technical Specs</h3>
                  <div className="space-y-2" data-id="element-622">
                    <div className="flex justify-between" data-id="element-623">
                      <span className="text-gray-600" data-id="element-624">Processor</span>
                      <span className="font-medium" data-id="element-625">Apple M1 Pro</span>
                    </div>
                    <div className="flex justify-between" data-id="element-626">
                      <span className="text-gray-600" data-id="element-627">Memory</span>
                      <span className="font-medium" data-id="element-628">16GB</span>
                    </div>
                    <div className="flex justify-between" data-id="element-629">
                      <span className="text-gray-600" data-id="element-630">Storage</span>
                      <span className="font-medium" data-id="element-631">512GB SSD</span>
                    </div>
                    <div className="flex justify-between" data-id="element-632">
                      <span className="text-gray-600" data-id="element-633">Display</span>
                      <span className="font-medium" data-id="element-634">
                        14-inch Liquid Retina XDR
                      </span>
                    </div>
                  </div>
                </div>
                <div className="bg-gray-50 p-4 rounded-lg" data-id="element-635">
                  <h3 className="font-medium mb-2" data-id="element-636">Physical Specs</h3>
                  <div className="space-y-2" data-id="element-637">
                    <div className="flex justify-between" data-id="element-638">
                      <span className="text-gray-600" data-id="element-639">Dimensions</span>
                      <span className="font-medium" data-id="element-640">
                        12.31 x 8.71 x 0.61 inches
                      </span>
                    </div>
                    <div className="flex justify-between" data-id="element-641">
                      <span className="text-gray-600" data-id="element-642">Weight</span>
                      <span className="font-medium" data-id="element-643">3.5 lbs (1.6 kg)</span>
                    </div>
                    <div className="flex justify-between" data-id="element-644">
                      <span className="text-gray-600" data-id="element-645">Color</span>
                      <span className="font-medium" data-id="element-646">Space Gray</span>
                    </div>
                    <div className="flex justify-between" data-id="element-647">
                      <span className="text-gray-600" data-id="element-648">Ports</span>
                      <span className="font-medium" data-id="element-649">
                        Thunderbolt 4, HDMI, SD card
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Related Products */}
        <div className="mt-12" data-id="element-650">
          <h2 className="text-2xl font-bold mb-6" data-id="element-651">Similar Products</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-id="element-652">
            {relatedProducts.map(product => <div key={product.id} className="bg-white rounded-xl shadow-sm overflow-hidden" data-id="element-653">
                <div className="p-4" data-id="element-654">
                  <h3 className="font-semibold mb-1" data-id="element-655">{product.name}</h3>
                  <p className="text-sm text-gray-500 mb-3" data-id="element-656">
                    {product.condition}
                  </p>
                  <div className="aspect-w-16 aspect-h-9 mb-4 flex items-center justify-center" data-id="element-657">
                    <img src={product.image} alt={product.name} className="object-contain h-32 mx-auto" data-id="element-658" />
                  </div>
                  <div className="flex items-center justify-between mb-3" data-id="element-659">
                    <div data-id="element-660">
                      <span className="text-lg font-bold" data-id="element-661">
                        ${product.price}
                      </span>
                      {product.originalPrice && <span className="text-sm text-gray-500 line-through ml-2" data-id="element-662">
                          ${product.originalPrice}
                        </span>}
                    </div>
                    {product.discount && <span className="text-green-600 text-sm font-semibold" data-id="element-663">
                        -{product.discount} OFF
                      </span>}
                  </div>
                  <button className="w-full bg-green-500 text-white py-2 rounded-lg hover:bg-green-600 transition-colors" data-id="element-664">
                    View Details
                  </button>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </div>;
};